import { faCircleDot } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { ThemeContext } from "../theme/ThemeContext";
import "./UserDataDesktop.scss";

const UserDataDesktop = ({ data }) => {
  const theme = useContext(ThemeContext);

  return (
    <div className="columns is-mobile mt-4 is-centered ">
      <div className="column is-10 is-centered">
        <div
          className="columns has-text-centered p-6"
          style={{
            padding: "5px",
            borderRadius: "1rem",
            boxShadow:
              "0rem 0em 1em 0.5em rgba(43, 43, 43, 0.1), 0 0px 0 1px rgba(43, 43, 43, 0.02)",
          }}
        >
          <div
            style={{ borderRight: "1px solid #ccc" }}
            className="column is-flex is-justify-content-flex-start data-tab"
          >
            <div className="columns">
              <div
                className="circle-icon-user-data"
                style={{
                  height: "100%",
                  width: "50px",
                  padding: "0.75rem",
                  display: "table-cell",
                  verticalAlign: "middle",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    height: "36px",
                    width: "100%",

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "inline-block" }}>
                    <FontAwesomeIcon
                      size="2x"
                      className={`has-text-${theme.purpleCircle} `}
                      icon={faCircleDot}
                    />
                  </div>
                </div>
              </div>
              <div className="column">
                <div className={`has-text-${theme.iconColor} has-text-left is-size-4`}>
                  <b>OPĆI PODACI</b>
                </div>
                <div className="columns is-mobile mt-3">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">Ime:</p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.generalInfo?.ime}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">Prezime:</p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.generalInfo?.prezime}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">
                      Adresa stanovanja:
                    </p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.generalInfo?.adresa}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">
                      Mjesto stanovanja:
                    </p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.generalInfo?.mjesto}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">Telefon:</p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.generalInfo?.telefon}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">Mobitel:</p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.generalInfo?.mobitel}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">e-mail:</p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.generalInfo?.email}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Novi Tab */}
          <div
            style={{ borderRight: "1px solid #ccc" }}
            className="column is-flex is-justify-content-flex-start data-tab"
          >
            <div className="columns">
              <div
                className="circle-icon-user-data"
                style={{
                  height: "100%",
                  width: "50px",
                  padding: "0.75rem",
                  display: "table-cell",
                  verticalAlign: "middle",
                  textAlign: "center",
                  marginLeft: "2rem",
                }}
              >
                <div
                  style={{
                    height: "36px",
                    width: "100%",

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "inline-block" }}>
                    <FontAwesomeIcon
                      size="2x"
                      className={`has-text-${theme.purpleCircle} `}
                      icon={faCircleDot}
                    />
                  </div>
                </div>
              </div>
              <div className="column">
                <div className={`has-text-${theme.iconColor} has-text-left is-size-4`}>
                  <b>PODACI O LICENCI</b>
                </div>
                <div className="columns is-mobile mt-3">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">
                      Vrijedi od-do:
                    </p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.licenceInfo?.razdoblje}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">Kategorija:</p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.licenceInfo?.kategorija}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* NOVI TAB */}
          <div className="column is-flex is-justify-content-flex-start data-tab">
            <div className="columns">
              <div
                className="circle-icon-user-data"
                style={{
                  height: "100%",
                  width: "50px",
                  padding: "0.75rem",
                  display: "table-cell",
                  verticalAlign: "middle",
                  textAlign: "center",
                  marginLeft: "2rem",
                }}
              >
                <div
                  style={{
                    height: "36px",
                    width: "100%",

                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "inline-block" }}>
                    <FontAwesomeIcon
                      size="2x"
                      className={`has-text-${theme.purpleCircle} `}
                      icon={faCircleDot}
                    />
                  </div>
                </div>
              </div>
              <div className="column">
                <div className={`has-text-${theme.iconColor} has-text-left is-size-4`}>
                  <b>PODACI O ZAPOSLENJU</b>
                </div>
                <div className="columns is-mobile mt-3">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">Podružnica:</p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.employmentInfo?.podruznica}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">
                      Ustanova zaposlenja:
                    </p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.employmentInfo?.ustanova}
                    </p>
                  </div>
                </div>
                <div className="columns is-mobile">
                  <div
                    style={{ whiteSpace: "nowrap" }}
                    className="column has-text-left is-flex-grow-0"
                  >
                    <p className="bd-notification is-info has-text-weight-semibold">
                      Područje djelatnosti:
                    </p>
                  </div>
                  <div className="column has-text-left pl-1">
                    <p className={`has-text-${theme.iconColor} bd-notification is-info is-italic`}>
                      {data?.employmentInfo?.djelatnost}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End of last tab */}
        </div>
      </div>
    </div>
  );
};

export default UserDataDesktop;
